import {connect} from 'react-redux';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Table} from "antd";

class InfoList extends Component {

    static propTypes = {
        dataSourceFunc: PropTypes.func.isRequired,
        columns: PropTypes.array.isRequired,
        rowKey: PropTypes.string.isRequired,
    };

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
        }
    }

    componentDidMount = async () => {
        const dataSource = await this.props.dataSourceFunc();
        this.setState({
            dataSource: dataSource,
            loading: false,
        })
    }

    render() {
        if (this.state.loading) {
            return <p>Loading…</p>;
        }
        return (
            <Table
                className="project-table"
                columns={this.props.columns}
                dataSource={this.state.dataSource}
                pagination={this.state.dataSource.length > 10}
                bordered={false}
                rowKey={this.props.rowKey}
                style={{marginBottom: '30px'}}
            />
        );
    }
}

const mapStateToProps = (state) => {return {}}

export default connect(mapStateToProps)(InfoList);



// WEBPACK FOOTER //
// ./src/components/shared/infolist.js